import auth from '../auth-bundle/store/initialState';
import { configureStore } from '../core-bundle/store/create-store';
import transferUpload from '../transfer-bundle/store/initial-state';
import reducers from '@wetransfer/transfer/store/reducer';

import { initialState as currentOrder } from './currentOrder';
import { initialState as customWallpapers } from './customWallpapers';

// Import initial state helpers
import account from './helper/account';
import getChannel from './helper/channel';
import consent from './helper/consent';
import layout from './helper/layout';
import notification from './helper/notification';
import pending from './helper/pending';
import route from './helper/route';
import session from './helper/session';
import transfer from './helper/transfer';
import ui from './helper/ui';
import upload from './helper/upload';
import uploadNotifications from './helper/upload-notifications';
import user from './helper/user';
import { initialState as paymentIntegrations } from './paymentIntegrations';

// Create our initial state
export const initialState = {
  // Some channel specific information
  channel: getChannel,

  layout,

  // This contains notifications (if needed)
  notification,

  // Everything that is pending in our app is stored here
  pending,

  // Some account specific information
  account: account as typeof account & Record<string, unknown>,

  // This contains the current route
  route,

  // Some session specific information
  session,

  // This contains the current Transfer object (up/down)
  // 1-to-1: A User can only have one active Transfer Object
  transfer,

  ui,

  billingDetails: {} as Record<any, unknown>,

  invoices: null as any,

  apiGrants: [] as any[],

  // Some user specific information
  user,

  transferUpload,

  upload,

  consent,

  auth,

  // State for the custom wallpapers feature
  customWallpapers,

  paymentIntegrations,

  currentOrder,

  // State for the upload notifications feature, audio and web notification
  uploadNotifications,
};

export default configureStore(initialState, reducers);

export const configureMockStore = (mockInitialState: any): any =>
  configureStore(mockInitialState, reducers);
